import React from 'react';

export interface PageHeaderProps {
  title: string;
  description?: string;
  /** Optional action area on the right (buttons, switches, etc.). */
  children?: React.ReactNode;
}

/**
 * Page header used at the top of every screen. Layout matches My.Tms.Old —
 * title (xl bold slate-700), optional description, optional right-side
 * action area, slate-200 bottom border.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, description, children }) => {
  return (
    <div className="mb-1.5 border-b border-slate-200">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-xl font-bold text-slate-700">{title}</h1>
          {description && <p className="text-slate-600">{description}</p>}
        </div>
        {children ? (
          <div className="flex items-center gap-3">{children}</div>
        ) : (
          <div className="mb-9">&nbsp;</div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
